import { render, staticRenderFns } from "./remnantOrder2.vue?vue&type=template&id=58d3d991&scoped=true&"
import script from "./remnantOrder2.vue?vue&type=script&lang=js&"
export * from "./remnantOrder2.vue?vue&type=script&lang=js&"
import style0 from "./remnantOrder2.vue?vue&type=style&index=0&id=58d3d991&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d3d991",
  null
  
)

export default component.exports